export const slide = (self, dir=null) => {
    const a = dir ? {'right': -1, 'left': 1}[dir] : 0
    const track = self.refs.track.clientWidth
    const children = self.refs.children.clientWidth
    const prev = self.state.position
    const delta = self.props.scroll * track
    const l = 0
    const r = track - children
    const position = Math.min(l, Math.max(r, prev + a * delta))
    return {
        position,
        leftMax : position === l,
        rightMax: position === r
    }
}

export const arrows = (self) => ({
    arrows: self.refs.track.clientWidth < self.refs.children.clientWidth
})



// WEBPACK FOOTER //
// ./src/components/slider-service.js